if (!customElements.get('toggle-item')) {
  class ToggleItem extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-toggle-item-btn]');
      this.button.addEventListener('click', this.handleToggle.bind(this));
      this.siblings = this.parentElement.querySelectorAll('toggle-item');
    }

    handleToggle() {
      this.siblings.forEach((sibling) => {
        if (this !== sibling) {
          sibling.classList.remove('open');
        }
      });
      this.classList.toggle('open');
    }
  }

  customElements.define('toggle-item', ToggleItem);
}